package diana.soleil.design.iraniancanadienbazzar.core.firebase

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.messaging.messaging

/**
 * Retrieves the current Firebase Messaging registration token. Native notification permission is
 * requested by the Android/iOS app entry points; token retrieval stays shared and best-effort.
 */
interface PushMessagingService {
    suspend fun getToken(): String
}

internal class DefaultPushMessagingService : PushMessagingService {
    override suspend fun getToken(): String = Firebase.messaging.getToken()
}
